import { render, staticRenderFns } from "./NlpHowItWorksImageDesktop.vue?vue&type=template&id=1767728c&scoped=true"
import script from "./NlpHowItWorksImageDesktop.vue?vue&type=script&lang=js"
export * from "./NlpHowItWorksImageDesktop.vue?vue&type=script&lang=js"
import style0 from "./NlpHowItWorksImageDesktop.vue?vue&type=style&index=0&id=1767728c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767728c",
  null
  
)

export default component.exports